import { publicClient, privateClient } from './client';
import { LoginIdentity } from './LoginIdentity';

const transactionsLoginIdentity = (pub: boolean) => new LoginIdentity(pub ? publicClient : privateClient);
export default transactionsLoginIdentity;
